import { createEffect } from 'effector'
import { getXboxConnect, getXboxRefresh } from './api'

export const getXboxRefreshFx = createEffect(async (token: string) => {
  const data = await getXboxRefresh(token)
  return data
})
export const getXboxConnectFx = createEffect(async (token: string) => {
  const data = await getXboxConnect(token)
  return data
})
